module.exports = __webpack_public_path__ + "static/media/startpage2025_768.33dc43b6.png";